export enum CountryTypesValues {
    SaudiArabia = 'SAU',
    UAE = 'ARE',
    OMAN = 'OMN',
    BHR = 'BHR',
    KWT = 'KWT',
    QAT = 'QAT',
    EGY = 'EGY',
    PAK ='PAK',
    JOR = 'JOR'
}

export enum CountryTypeIds {
    SaudiArabia = 1048,
    UAE = 1047,
    OMN = 1052,
    BHR = 1051,
    KWT = 1050,
    QAT = 1049,
    EGY = 1055,
    PAK =13410,
    JOR = 1053,    
}

export enum BusinessTravel {
    Value = 'BT',
    Id = 16203
}
export enum Governance {
    Value = 'GOV',
    Id = 16204
}

